import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiShield, FiPlusCircle, FiUsers, FiUmbrella, FiAward } = FiIcons;

const BenefitsSection = () => {
  const benefits = [
    {
      icon: FiHeart,
      title: "Comprehensive Coverage",
      description: "Comprehensive medical, dental, and vision coverage with a choice of three medical plans, plus company-paid life and disability insurance."
    },
    {
      icon: FiPlusCircle,
      title: "Medical Options",
      description: "Choice of three medical plan options through Blue Cross Blue Shield and Blue Care Network."
    },
    {
      icon: FiShield,
      title: "Full Insurance",
      description: "Company-paid basic life insurance along with short-term and long-term disability insurance for your security."
    },
    {
      icon: FiUsers,
      title: "Family Support",
      description: "Flexible spending account (FSA) options for employees and families, with competitive company contributions."
    },
    {
      icon: FiUmbrella,
      title: "Retirement Plan",
      description: "401(k) retirement plan with company matching to help secure your long-term financial future."
    },
    {
      icon: FiAward,
      title: "Paid Training",
      description: "Professional development and certification programs to build your skilled trade career with MAG."
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-black text-black mb-6">
            The <span className="text-mag-green">MAG</span> Advantage
          </h2>
          <p className="text-xl text-black max-w-3xl mx-auto font-medium">
            We value our team and provide a benefits package that supports your health, wealth, and future.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border-b-4 border-mag-green hover:border-mag-blue"
            >
              <div className="w-14 h-14 bg-gray-50 rounded-2xl flex items-center justify-center mb-6 border border-gray-100">
                <SafeIcon icon={benefit.icon} className="w-7 h-7 text-mag-blue" />
              </div>
              <h3 className="text-xl font-bold text-black mb-4">
                {benefit.title}
              </h3>
              <p className="text-black leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;